import {
    eventListPending,
    eventListPrevious,
    eventListUpcoming,
    eventTextShortDescription,
    eventView
} from "./eventApi";
import {testAdminLoader} from "../contact/contactLoader";
import {conversationList} from "../conversation/conversationApi";

export const upcomingEventLoaders = async () => {
    await (() => setTimeout(null, 1));

    const upcomingEventsRes = await eventListUpcoming();
    return upcomingEventsRes.data;
};

export const pendingEventLoaders = async (params) => {
    await testAdminLoader(params);

    const pendingEventsRes = await eventListPending();
    return pendingEventsRes.data.filter((event) => event.label);
};

export const previousEventLoader = async () => {
    await (() => setTimeout(null, 1));

    const previousEventsRes = await eventListPrevious();
    return previousEventsRes.data;
}

export const eventLoader = async ( request ) => {
    await testAdminLoader(request);

    const eventEntityId = request.params.id;
    const eventRes = await eventView( eventEntityId );
    const event = eventRes.data;
    const shortDescriptionRes = await eventTextShortDescription(eventEntityId);
    event.shortDescription = shortDescriptionRes.data;
    const conversationsRes = await conversationList();
    return {event, conversations: conversationsRes.data};
}

